module.exports = __webpack_public_path__ + "img/attention.5ecffea6.png";